import styled, { keyframes } from 'styled-components';

const scrollLeft = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const IntroCopy = styled.p`
  text-align: center;
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 500;
  white-space: nowrap;
  margin: 0 0 2.5rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    white-space: normal;
    padding: 0 1rem;
  }
`;

export const MarqueeWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-bottom: 4rem;
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    #000 10%,
    #000 90%,
    transparent
  );
  mask-image: linear-gradient(to right, transparent, #000 10%, #000 90%, transparent);
`;

export const MarqueeTrack = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  animation: ${scrollLeft} 30s linear infinite;
`;

export const ClubLogo = styled.img`
  height: 80px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
  margin-right: 4.5rem;
  opacity: 0.85;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

export const TestimonialsMarqueeWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const TestimonialsMarqueeTrack = styled.div`
  display: flex;
  align-items: stretch;
  width: max-content;
  animation: ${scrollLeft} 45s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;
